import { z } from "zod";
/** Blast radius replaces tier (EMMA-GOVERNANCE-CONSOLIDATED.md §3).
 *  0 reads · 1 internal notes · 2 our records · 3 money · 4 a real person. */
export const BlastRadius = z.union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
]);
export const RADIUS_LABEL = {
    0: "reads",
    1: "internal notes",
    2: "our records",
    3: "money",
    4: "a real person",
};
/** Policy verdict for command × role × surface × radius (bb.policy). What is
 *  auto-approved is a policy ROW, not a deploy. */
export const PolicyOutcome = z.enum(["auto", "ask", "deny"]);
/** aiw.data_origin — every AIW row carries it (ADR-006). */
export const DataOrigin = z.enum(["live", "synced", "test"]);
//# sourceMappingURL=radius.js.map